import { render, staticRenderFns } from "./paperCertList.vue?vue&type=template&id=7164cd2c&scoped=true&"
import script from "./paperCertList.vue?vue&type=script&lang=js&"
export * from "./paperCertList.vue?vue&type=script&lang=js&"
import style0 from "./paperCertList.vue?vue&type=style&index=0&id=7164cd2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7164cd2c",
  null
  
)

export default component.exports